import { useTranslation } from 'react-i18next'

import { ActionModal, Modal, Typography } from '@percent/lemonade'

export type RemoveDefaultTemplateModalProps = {
  open: boolean
  handleClose: VoidFunction
  handleRemoveDefault: VoidFunction
  isLoading: boolean
}

export function RemoveDefaultTemplateModal({
  open,
  handleClose,
  handleRemoveDefault,
  isLoading
}: Readonly<RemoveDefaultTemplateModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="remove-default-template-modal">
      <ActionModal
        title={t('dialog.templates.removeDefault.title')}
        primaryButtonText={t('button.remove')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={handleRemoveDefault}
        loading={isLoading}
      >
        <Typography>{t('dialog.templates.removeDefault.description')}</Typography>
        <Typography>{t('dialog.templates.removeDefault.confirmation')}</Typography>
      </ActionModal>
    </Modal>
  )
}
